import { render, staticRenderFns } from "./Thresholds.vue?vue&type=template&id=95c33dce&scoped=true"
import script from "./Thresholds.vue?vue&type=script&lang=js"
export * from "./Thresholds.vue?vue&type=script&lang=js"
import style0 from "./Thresholds.vue?vue&type=style&index=0&id=95c33dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c33dce",
  null
  
)

export default component.exports